export const i18n = {
    confirmationModal: {
        discardButton: 'Discard',
        saveButton: 'Save',
    },
    datePicker: {
        locale: 'en',
    },
    form: {
        notifications: {
            actionButtonCaption: 'Restore',
            declineButtonCaption: 'Decline',
            unsavedChangesMessage: 'You have unsaved changes. Click Restore to recover the data, or Decline to discard it',
        },
        modals: {
            beforeLeaveMessage: 'Your data may be lost. Do you want to save data?',
        },
    },
    notificationCard: {
        closeAllNotificationsButton: 'CLOSE ALL NOTIFICATIONS',
    },
    dataPickerBody: {
        searchPlaceholder: 'Search',
        noResultsMessage: 'No Results found',
    },
    pickerModal: {
        headerTitle: 'Please select',
        searchPlaceholder: 'Type text for quick search',
        cancelButton: 'Cancel',
        selectButton: 'Select',
        clearSelectionButton: 'CLEAR ALL',
        selectAllButton: 'SELECT ALL',
    },
    pickerFilterHeader: {
        sortAscending: 'Sort Ascending',
        sortDescending: 'Sort Descending',
    },
    pickerInput: {
        showOnlySelectedLabel: 'Show only selected',
        clearSelectionButton: 'CLEAR ALL',
        selectAllButton: 'SELECT ALL',
    },
    tables: {
        columnsConfigurationModal: {
            applyButton: 'Apply',
            cancelButton: 'Cancel',
            selectAllButton: 'Select all',
            clearAllButton: 'Clear all',
            checkAllButton: 'Check All',
            uncheckAllButton: 'Uncheck All',
            configureColumnsTitle: 'Configure columns',
            resetToDefaultButton: 'Reset to Default',
            displayedSectionTitle: 'Displayed in table',
            hiddenSectionTitle: 'Hidden in table',
            searchPlaceholder: 'Search by column name',
            noResultsFound: {
                text: 'No results found',
                subText: 'We can’t find any item matching your request',
            },
            enableAtLeastOneColumnMessage: 'Please enable at least one column',
            pinColumnButton: 'Pin column',
            unPinColumnButton: 'Unpin column',
            lockedColumnPinButton: 'You cannot unpin this column',
        },
    },
    sliderRating: {
        notAvailableMessage: 'Not Available',
    },
    rangeDatePicker: {
        pickerPlaceholderFrom: 'From:',
        pickerPlaceholderTo: 'To:',
    },
};
